var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1vw",
    height: ".9vw",
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 13.5L10.3333 10.8333M11.6667 6.83333C11.6667 8.24782 11.1048 9.60438 10.1046 10.6046C9.10438 11.6048 7.74782 12.1667 6.33333 12.1667C4.91885 12.1667 3.56229 11.6048 2.5621 10.6046C1.5619 9.60438 1 8.24782 1 6.83333C1 5.41885 1.5619 4.06229 2.5621 3.0621C3.56229 2.0619 4.91885 1.5 6.33333 1.5C7.74782 1.5 9.10438 2.0619 10.1046 3.0621C11.1048 4.06229 11.6667 5.41885 11.6667 6.83333Z",
    stroke: "#FCFAFA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.497406c5a39a4d0ae9928f3dd578261e.svg";
export { ForwardRef as ReactComponent };